import React, { useEffect, useState } from 'react';
import { Area, AreaChart, Bar, BarChart, CartesianGrid, Legend, Line, LineChart, Pie, PieChart, Tooltip, XAxis, YAxis } from 'recharts';
import './Dashboard.css';

const Dashboard = () => {
        const [data, setData] = useState([]);
        // Load Chart's Data:
        useEffect(() => {
                fetch('data.json')
                        .then(res => res.json())
                        .then(data => setData(data))
        }, [])
        return (
                <div className="brand-bg mt-5 pt-5 pb-5">
                        <div className="container pt-5">
                                <div className="row">
                                        {/* Investment Vs Revenue Line Chart */}
                                        <div className="col-md-6">
                                                <h3 className="brand-color text-center mb-4 mt-4">Month Wise Sell</h3>
                                                <div className="d-flex justify-content-center">
                                                        <LineChart width={300} height={300} data={data}>
                                                                <XAxis dataKey={'month'} stroke="white"></XAxis>
                                                                <YAxis stroke="white"></YAxis>
                                                                <Line dataKey={'sell'} stroke="#adff2f"></Line>
                                                                <Tooltip />
                                                        </LineChart>
                                                </div>
                                        </div>
                                        {/* Investment Vs Revenue Area Chart */}
                                        <div className="col-md-6">
                                                <h3 className="brand-color text-center mb-4 mt-4">Investment Vs Revenue</h3>

                                                <div className="d-flex justify-content-center">
                                                        <AreaChart
                                                                width={300}
                                                                height={300}
                                                                data={data}
                                                                margin={{
                                                                        top: 10,
                                                                        right: 30,
                                                                        left: 0,
                                                                        bottom: 0,
                                                                }}
                                                        >
                                                                <XAxis dataKey={'month'} stroke="white"></XAxis>
                                                                <CartesianGrid strokeDasharray="3 3" />
                                                                <YAxis />
                                                                <Tooltip />
                                                                <Area type="monotone" dataKey="investment" stackId="1" stroke="#8884d8" fill="#8884d8" />
                                                                <Area type="monotone" dataKey="revenue" stackId="1" stroke="#82ca9d" fill="#82ca9d" />
                                                        </AreaChart>
                                                </div>

                                        </div>
                                </div>
                                <div className="row mt-5">
                                        {/* Investment Vs Revenue Bar Chart */}
                                        <div className="col-md-6">
                                                <h3 className="brand-color text-center mb-4 mt-5">Investment Vs Revenue</h3>
                                                <div className="d-flex justify-content-center">
                                                        <BarChart
                                                                width={300}
                                                                height={300}
                                                                data={data}
                                                                margin={{
                                                                        top: 20,
                                                                        right: 30,
                                                                        left: 20,
                                                                        bottom: 5,
                                                                }}
                                                        >
                                                                <CartesianGrid strokeDasharray="3 3" />
                                                                <YAxis />
                                                                <Tooltip />
                                                                <XAxis dataKey={'month'} stroke="white"></XAxis>
                                                                <Legend />
                                                                <Bar dataKey={"investment"} stackId="a" fill="#8884d8" />
                                                                <Bar dataKey={"revenue"} stackId="a" fill="#82ca9d" />
                                                        </BarChart>
                                                </div>
                                        </div>
                                        <div className="col-md-6">
                                                <h3 className="brand-color text-center mb-4 mt-5">Investment Vs Revenue</h3>
                                                <div className="d-flex justify-content-center">
                                                        <PieChart width={300} height={300}>
                                                                <Pie data={data} dataKey={"investment"} cx="50%" cy="50%" outerRadius={60} fill="#8884d8" />
                                                                <Pie data={data} dataKey={"revenue"} cx="50%" cy="50%" innerRadius={70} outerRadius={90} fill="#82ca9d" label />
                                                                <Tooltip />
                                                        </PieChart>
                                                </div>
                                        </div>
                                </div>
                        </div>
                </div>
        );
};

export default Dashboard;